import React, { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { observer } from "mobx-react";
import { toast } from "react-toastify";

import { useAPI } from "../../providers/ApiProvider";
import { useAppStore } from "../../providers/AppStoreProvider";
import { TOASTIFY_OPTIONS } from "../../config/ReactToastify";

import { CommentSkeleton } from "./CommentSkeleton";
import { CreateComment } from "./CreateComment";
import { CommentBlock } from "./CommentBlock";

import "./Comments.scss";

export const Comments = observer(() => {
  const store = useAppStore();
  const api = useAPI();
  const [searchParams] = useSearchParams();
  const [isCommentLoading, setIsCommentLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [meta, setMeta] = useState();
  const commentsRef = useRef();

  useEffect(() => {
    const comment_id = searchParams.get("comment_id");

    store.setComments([]);
    setIsLoading(true);

    if (comment_id) {
      setTimeout(() => {
        store.setTab("comment");
        setIsCommentLoading(true);
        api
          .callApi("commentBlock", { params: { pk: comment_id } })
          .then((res) => {
            store.addComments(res.data.comment, "unshift");
            commentsRef.current.scrollIntoView();
          })
          .catch((e) => {
            console.log(e);
            toast.error("Không tìm thấy bình luận", TOASTIFY_OPTIONS);
          })
          .finally((e) => {
            setIsCommentLoading(false);
          });
      }, 0);
    }

    fetchComments();
  }, []);

  const fetchComments = () => {
    setIsLoading(true);
    api
      .callApi("commentByCourse", {
        params: { courseId: store.course.id, page: (meta?.current_page ?? 0) + 1 },
      })
      .then((res) => {
        const { total, per_page, current_page, total_pages } = res.data.comments.meta;

        store.addComments(res.data.comments.items);
        setMeta({ total, per_page, current_page, total_pages });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div ref={commentsRef} className="comments">
      {store.user && store.hasPermission("create_comment") && store.currentLesson?.id && (
        <CreateComment />
      )}

      {isCommentLoading && <CommentSkeleton />}

      {store.comments?.map((commentBlock) => (
        <CommentBlock commentBlock={commentBlock} key={commentBlock.id} />
      ))}

      {isLoading && [...Array(3)].map((_, index) => <CommentSkeleton key={`skeleton-${index}`} />)}

      {!isLoading && meta?.current_page !== meta?.total_pages && (
        <div
          role="button"
          className="btn-loadmore fw-semibold mt-4 text-gray"
          onClick={fetchComments}
        >
          Xem thêm {meta.total - meta.current_page * meta.per_page} bình luận
        </div>
      )}
    </div>
  );
});
